/**
 * NOVAPAY-116 / COMMERCE-LAUNCH-164A-R1 — TEST / SANDBOX marker.
 * COMMERCE-LAUNCH-168D4 — never show on production-mode Customer bake.
 */
import type { StoreV2Lang } from "./store-v2-locale.js";
import { t } from "./store-v2-ui-copy.js";
import {
  isNovapayCheckoutDegradedStaging,
  isNovapayProductionUiEnabled,
} from "./novapay-staging-degraded-v2.js";

export function NovapaySandboxBadge({
  lang = "ua",
  testId = "sv2-novapay-sandbox-badge",
}: {
  lang?: StoreV2Lang;
  testId?: string;
}) {
  if (isNovapayProductionUiEnabled()) return null;
  if (isNovapayCheckoutDegradedStaging()) return null;
  const l: StoreV2Lang = lang === "en" ? "en" : "ua";
  return (
    <div className="sv2-novapay-sandbox-badge" data-testid={testId} role="note">
      <strong>{t(l, "novapay_sandbox_badge_title")}</strong>
      <span className="sv2-muted">{t(l, "novapay_sandbox_badge_body")}</span>
    </div>
  );
}
